import { ArrowRight, CheckCircle2, Droplets, Ruler, ShieldCheck, SunMedium, Wind } from "lucide-react";
import { useState } from "react";
import { Link } from "../app/router";
import { Notice } from "../components/Notice";
import { PageMeta } from "../components/PageMeta";

const checks = [
  "Đã đo rộng × sâu phần sàn sử dụng",
  "Đã chụp hướng cửa và cục nóng điều hòa",
  "Đã quan sát số giờ nắng trực tiếp",
  "Đã xác định nguồn nước và lỗ thoát",
  "Đã hỏi nội quy ban quản lý tòa nhà",
];

export function GuidePage() {
  const [done, setDone] = useState<string[]>([]);
  const toggle = (label: string) => setDone((current) => current.includes(label) ? current.filter((entry) => entry !== label) : [...current, label]);

  return (
    <>
      <PageMeta
        title="Cẩm nang đo ban công | Rêu Nắng"
        description="Checklist 5 phút về kích thước, nắng, gió, nước và an toàn gia đình."
      />
      <section className="page-intro guide-intro">
        <div className="container intro-split">
          <div><span className="eyebrow">Đo trước, mua sau</span><h1>Năm phút để bản phác bớt một lần đoán.</h1></div>
          <p className="lead">Bạn không cần bản vẽ kỹ thuật. Chỉ cần năm tín hiệu đủ tốt để công cụ không chọn cây và đồ trong bóng tối.</p>
        </div>
      </section>
      <section className="section guide-section">
        <div className="container guide-layout">
          <aside className="guide-checklist">
            <div className="checklist-progress">
              <span>{done.length}/5</span>
              <div><strong>Checklist đo 5 phút</strong><small>{done.length === 5 ? "Đủ tín hiệu để bắt đầu" : "Tích khi bạn đã kiểm tra"}</small></div>
            </div>
            <div className="progress-track" aria-hidden="true"><i style={{ width: `${done.length * 20}%` }} /></div>
            {checks.map((label) => (
              <label key={label} className={done.includes(label) ? "checked" : ""}>
                <input type="checkbox" checked={done.includes(label)} onChange={() => toggle(label)} />
                <span>{label}</span>
              </label>
            ))}
            <button className="text-button" type="button" onClick={() => setDone([])}>Làm lại checklist</button>
            <Link className="button button-primary" to="/thiet-ke">Mở Xưởng ban công <ArrowRight aria-hidden="true" /></Link>
          </aside>
          <article className="guide-article">
            <section>
              <span className="guide-icon"><Ruler aria-hidden="true" /></span>
              <div><span className="eyebrow">01 · Kích thước</span><h2>Đo phần sàn có thể dùng.</h2><p>Đo rộng theo mặt lan can, sâu từ cửa đến lan can. Ghi lại cục nóng, hộp kỹ thuật và quỹ đạo cửa mở; đừng trừ lối đi bằng mắt.</p></div>
            </section>
            <section>
              <span className="guide-icon"><SunMedium aria-hidden="true" /></span>
              <div><span className="eyebrow">02 · Nắng</span><h2>Quan sát giờ nắng, không chỉ nhìn hướng.</h2><p>Nhà đối diện, mái che và mùa có thể làm hai ban công cùng hướng nhận nắng khác nhau. Trong demo, 2–4 giờ nắng sáng được xếp “nắng sáng”.</p></div>
            </section>
            <section>
              <span className="guide-icon"><Wind aria-hidden="true" /></span>
              <div><span className="eyebrow">03 · Gió</span><h2>Nhìn cách lá và rèm phản ứng.</h2><p>Nếu rèm thường bị kéo mạnh hoặc lá rung liên tục, chọn “lộng gió”. Công cụ sẽ loại chậu treo và cây chịu gió kém.</p></div>
            </section>
            <section>
              <span className="guide-icon"><Droplets aria-hidden="true" /></span>
              <div><span className="eyebrow">04 · Nước</span><h2>Tìm cả vòi vào lẫn đường thoát.</h2><p>Chậu cần kê khỏi sàn và nước thừa phải đi đúng lỗ thoát. Nguồn nước xa làm chậu tự tưới đáng cân nhắc hơn, không có nghĩa là bỏ được việc kiểm tra ẩm.</p></div>
            </section>
            <section>
              <span className="guide-icon"><ShieldCheck aria-hidden="true" /></span>
              <div><span className="eyebrow">05 · Nếp nhà</span><h2>Nói trước về trẻ nhỏ và thú cưng.</h2><p>Demo loại cây pet-unsafe khỏi recommendation và tránh cây gai khi có trẻ nhỏ. Danh sách không thay thế tư vấn thú y hoặc đánh giá an toàn tại nhà.</p></div>
            </section>
            <Notice tone="warning" title="Bản phác không phải kết luận kỹ thuật.">
              <p>Hãy kiểm tra tải trọng, chống thấm, thoát nước, nguồn điện, liên kết vào tường và nội quy tòa nhà trước khi thi công.</p>
            </Notice>
            {done.length === 5 && (
              <div className="guide-success" role="status">
                <CheckCircle2 aria-hidden="true" />
                <div><strong>Bạn đã có đủ năm tín hiệu nền.</strong><p>Mở công cụ và nhập lại các giá trị đã đo.</p></div>
              </div>
            )}
          </article>
        </div>
      </section>
    </>
  );
}
